import { render, staticRenderFns } from "./SAndLCreatedAddChapters.vue?vue&type=template&id=6ebed967&scoped=true&"
import script from "./SAndLCreatedAddChapters.vue?vue&type=script&lang=ts&"
export * from "./SAndLCreatedAddChapters.vue?vue&type=script&lang=ts&"
import style0 from "./SAndLCreatedAddChapters.vue?vue&type=style&index=0&id=6ebed967&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebed967",
  null
  
)

export default component.exports